import { render, staticRenderFns } from "./TabsWidget.vue?vue&type=template&id=f0701ff8&scoped=true"
import script from "./TabsWidget.vue?vue&type=script&lang=js"
export * from "./TabsWidget.vue?vue&type=script&lang=js"
import style0 from "./TabsWidget.vue?vue&type=style&index=0&id=f0701ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_babel-core@6.26.3_cache-loader@4.1.0_webpac_98d88fd53c1ad5e44e79d7b0571b6b60/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0701ff8",
  null
  
)

export default component.exports